module.exports = __webpack_public_path__ + "img/testimonial-7-61x61_1testimonial-7-61x61.d09f2642.png";